import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetCateringFormatBySlugApiResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            name: z.string(),
            slug: z.string(),
            description: z.any().optional().nullable(),
            images: z.array(
                z.object({
                    url: z.string(),
                }),
            ).optional().nullable(),
            menus: z.array(
                z.object({
                    name: z.string(),
                    description: z.any().optional().nullable(),
                    warning: z.string().optional().nullable(),
                    estimateFile: z.object({
                        url: z.string(),
                    }),
                    image: z.object({
                        url: z.string(),
                    }),
                }),
            ).optional().nullable(),
        }),
    ),
});

type GetCateringFormatBySlugApiResponse
    = ApiResponse<z.infer<typeof GetCateringFormatBySlugApiResponseSchema>>
    | BaseError;

type GetCateringFormatBySlugActionRequest = {
    slug: string
}

export const getCateringFormatBySlug = createAsyncThunk<
    GetCateringFormatBySlugApiResponse,
    GetCateringFormatBySlugActionRequest
>(
    'CateringFormatPageActionsGetCateringFormatBySlug',
    async ({
        slug,
    }) => apiInstance.get(
        '/catering-formats',
        {
            'filters[slug][$eq]': slug,
            'populate[images][fields]': 'url',
            'populate[menus][fields]': '*',
            'populate[menus][populate][estimateFile][fields]': 'url',
            'populate[menus][populate][image][fields]': 'url',
        },
        GetCateringFormatBySlugApiResponseSchema,
    ),
);
